import React from "react";
import { MusicHallDetailContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import moment from "moment";
import { toast } from "react-toastify";
import { RENDER_BOOKING_STATUS_TO_STEP } from "utils/functions/musicHall";
import { BookingStepWidget } from "widgets";
import { Cards, Displays } from "components";
import { AlertControl } from "components/Modals/Alert";
import { ROUTE_PATH } from "utils/constants/routePath";
import { MdChevronLeft, MdDeleteOutline } from "react-icons/md";

// ลบได้เฉพาะการจองที่สร้างมาไม่เกินกี่วัน ต้องตรงกับ BOOKING_DELETE_MAX_DAYS ฝั่ง API
const BOOKING_DELETE_MAX_DAYS = 30;

class MusicHallDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await portalService.GET_ROOM_BOOKING_DETAIL(router.params.id);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleBack = () => {
    const { router } = this.props;
    // เปิดจากลิงก์ตรง (ไม่มีหน้าก่อนหน้าใน app) navigate(-1) จะหลุดออกนอกระบบ ให้ไปหน้า list แทน
    if (window.history.state?.idx > 0) {
      router.navigate(-1);
    } else {
      router.navigate(ROUTE_PATH.MUSIC_HALL_BOOKING_LIST);
    }
  };

  // FLOW DELETE (soft delete ฝั่ง API, ยอดในบัญชีจะถูกกลับรายการ ณ วันที่ลบ)
  // =========================================
  handleClickDelete = () => {
    AlertControl.show({
      title: "ยืนยันการลบการจองนี้",
      description:
        "การจองจะหายจากรายการทั้งฝั่ง portal และฝั่งลูกค้า ถ้ามียอดเงินในเมนู Accounting จะถูกกลับรายการ ณ วันนี้",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยันลบ",
      onEvent2: this.handleConfirmDelete,
    });
  };
  handleConfirmDelete = async () => {
    const { router } = this.props;
    this.setState({ isBgLoading: true });
    let res = await portalService.DELETE_ROOM_BOOKING(router.params.id);
    if (res && res.status === 200) {
      this.setState({ isBgLoading: false });
      toast.success("ลบการจองสำเร็จ");
      router.navigate(ROUTE_PATH.MUSIC_HALL_BOOKING_LIST);
    } else {
      this.setState({ isBgLoading: false });
      toast.error(res?.data?.error?.message || "ลบการจองไม่สำเร็จ");
    }
  };

  render() {
    const { authenRedux } = this.props;
    const { isLoading, isBgLoading, data } = this.state;
    const step = !data ? 1 : RENDER_BOOKING_STATUS_TO_STEP(data.status);
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "music-hall-booking");
    const isCanDelete =
      !!data &&
      moment().diff(moment(data.created_at), "days", true) <=
        BOOKING_DELETE_MAX_DAYS;
    return (
      <MusicHallDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {/* ปุ่มกลับมีที่เดียวบนซ้าย (เดิมมี Back ท้ายทุกการ์ด ทำให้งง) */}
        <div className="back_bar">
          <div className="btn_back" onClick={this.handleBack}>
            <MdChevronLeft className="btn_back_icon" size={22} />
            <span>กลับ</span>
          </div>
          {/* เกิน 30 วันหลังสร้างการจอง ยังโชว์ปุ่มแต่กดไม่ได้ พร้อมบอกเหตุผล แอดมินจะได้ไม่งงว่าปุ่มหายไปไหน */}
          {data && permission && permission.is_delete && (
            <div className="delete_wrap">
              {!isCanDelete && (
                <span className="delete_hint">
                  ลบได้ภายใน {BOOKING_DELETE_MAX_DAYS} วันหลังสร้างการจอง
                </span>
              )}
              <div
                className={`btn_delete ${isCanDelete ? "" : "disabled"}`}
                onClick={isCanDelete ? this.handleClickDelete : undefined}
              >
                <MdDeleteOutline size={18} />
                <span>ลบการจอง</span>
              </div>
            </div>
          )}
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="sec_layout">
              <div className="detail_row">
                <div className="detail_col">
                  <div className="title">Booking Detail</div>
                  <Cards.RoomInfo {...data} />
                </div>
                <div className="detail_col">
                  <div className="title">Customer Detail</div>
                  <Cards.CustomerInfo {...data} />
                </div>
              </div>
            </div>
            <div className="booking_step_layout">
              <BookingStepWidget currentStep={step} />
            </div>
            <div className="sec_layout">
              <Cards.StatusInfo
                {...data}
                step={step}
                onSuccess={this.fetchData}
              />
            </div>
            {(data.status === "3" ||
              data.status === "4" ||
              data.status === "5") && (
              <div className="sec_layout">
                <Cards.PaymentInfo
                  {...data}
                  onSuccess={this.fetchData}
                />
              </div>
            )}
            <div className="sec_layout no_border">
              <Cards.BookingDetailInfo
                {...data}
                onSuccess={this.fetchData}
              />
            </div>
          </>
        )}
      </MusicHallDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

export default connect(mapStateToProps)(withRouter(MusicHallDetailContainer));
